import React from 'react'
import { Controller } from 'react-hook-form'
import CustomButton from '../../../UI/CustomButton/CustomButton'
import Field from '../../../UI/Field/Field'
import CustomDatepicker from '../../../UI/Form/CustomDatepicker'
import Input from '../../../UI/Form/Input'
import classes from './PricingSection.module.css'
import { AiOutlineMinus } from 'react-icons/ai'

const PricingSection = (props) => {
    const { index, control, onRemove } = props

    return (
        <div className={classes.main}>
            <div className={classes.header}>
                <h4>Ticket Price (Level {index + 1})</h4>
                <CustomButton className={classes.removeBut} onClick={() => onRemove(index)}>
                    <AiOutlineMinus/>
                    <span>Remove</span>
                </CustomButton>
            </div>
            <Controller
                name={`price.${index}.price`}
                control={control}
                defaultValue=""
                rules={{ required: "Required Field!" }}
                render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                    <Input
                        name={name}
                        onChange={onChange}
                        value={value}
                        error={error}
                        label="Price"  
                        regex="number"
                    />
                )}
            />
            <Field>
                <Controller
                    name={`price.${index}.start`}
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                        <CustomDatepicker
                            name={name}
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Start"  
                        />
                    )}
                />
                <Controller
                    name={`price.${index}.end`}
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                        <CustomDatepicker
                            name={name}
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="End"  
                        />
                    )}
                />
            </Field>
        </div>
    )
}

export default PricingSection